import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
import { HttpClient } from '@angular/common/http';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { OverlayEventDetail } from '@ionic/core';
import { ModalController } from '@ionic/angular';

import { AppComponent } from '../app.component';
import { AjaxService } from '../ajax.service';
import { ScanCameraPage } from '../scan-camera/scan-camera.page';

interface ApiResponse {
    login: boolean;
    var: string[];
    msg?: string;
    version?: string;
}

@Component({
    selector: 'app-login',
    templateUrl: './login.page.html',
    styleUrls: ['./login.page.scss'],
    standalone: false
})
export class LoginPage implements OnInit {
    firstTime = true;
    inpCompany = '';
    inpUsr = '';
    inpPwd = '';
    autoLogin = false;
    autoLoginEnabled = false;
    public showpwd = false;
    public wait = false;
    scanCamera = false;

    errmsg: string;

    task: any = null;

    @ViewChild('inpUsrFld') inpUsrFld;
    @ViewChild('inpCmpFld') inpCmpFld;
    @ViewChild('inpPwdFld') inpPwdFld;

    constructor(
        private router: Router,
        public global: GlobalService,
        public http: HttpClient,
        public modalController: ModalController,
        private ajax: AjaxService,
        public app: AppComponent
    ) {
    }

    async ngOnInit() {
        this.global.isLoggedIn = false;

        const info = await Device.getInfo();
        this.global.devInfo = `${info.manufacturer}:${info.model}/${info.operatingSystem}:${info.osVersion}/${info.platform}`;
        this.global.MyPlatform = info.platform;
        this.global.devID = (await Device.getId()).identifier;
        this.inpCompany = localStorage.getItem('company');
        this.autoLoginEnabled = ((info.platform=='android') || (info.platform=='ios') || (this.inpCompany=='dev')) && (this.global.devID !== '');
        if (this.inpCompany === 'dev') {
            this.global.baseurl = 'http://localhost/dev/';
        }
        this.autoLogin = (localStorage.getItem('autoLogin') === '1');
        if (!this.autoLogin) { this.firstTime = false; }
        this.wait = this.autoLogin;

        let uuid: string = localStorage.getItem('uuid');
        if (!uuid) {
            uuid = 'LI#' + String(Math.floor((Math.random() * 1000000000000000) + 1));
            localStorage.setItem('uuid', uuid);
        }
        console.log('uuid=' + uuid);
        this.global.uuid = uuid;

        if (this.inpCompany) {
            this.inpCompany = this.inpCompany.toLowerCase();
        }
        this.inpUsr = localStorage.getItem('user');

        const hideOpt = localStorage.getItem('hideScanBtn');
        this.global.optHideScanBtn = (hideOpt === '1');
        if (this.global.MyPlatform==='web' || info.model==='Memor 1' || info.model==='Memor K') {
            this.global.optHideScanBtn = true;
        }

        if (this.global.MyPlatform === 'ios') {
            this.global.baseurl = 'https://cloud1.lisaas.com/lipronics/';
        }

        this.task = setInterval(() => {
            const onLoginPage = this.router.isActive('login', false);
            if (!onLoginPage) {
                this.ajax.get('ping')
                    .then((dataping: any) => {
                        if (dataping.msg === 'LOGOUT') {
                            this.global.isLoggedIn = false;
                            this.errmsg = null;
                            this.router.navigateByUrl('login');
                        }
                    });
                console.log('PING');
            } else {
                console.log('Logged out');
            }
        }, 30000);

        this.ajax.get('logout', {
            compname: this.inpCompany,
            username: this.inpUsr,
            password: this.inpPwd,
        }).then((data: any) => {
            console.log('user logged out.');
            if (this.autoLogin && this.autoLoginEnabled) {
                if (this.firstTime) {
                    this.ajax.get('login', {
                        compname: '',
                        username: '',
                        password: '',
                        pcnr: this.global.uuid,
                        devID: this.global.devID,
                        autoLogin: this.autoLogin,
                    }).then(async (data: any) => {
                        console.log('autoLogin: ', data);
                        if (data.login) {
                            console.log('autoLogin succesfull');
                            await this.processLoginData(data);
                            await this.router.navigateByUrl(this.global.startPage);
                            await this.delay(500);
                            this.wait = false;
                            this.firstTime = false;
                        } else {
                            console.log('autoLogin failure');
                            this.errmsg = data.msg;
                            this.wait = false;
                            this.firstTime = false;
                        }
                    }, error => {
                        console.log('Autologin Communicatie error: ', error);
                        this.errmsg = 'Error contacting server. Check your connection.';
                        this.wait = false;
                        this.firstTime = false;
                    });
                }
            }
        });
        this.global.session = '';
        this.global.isLoggedIn = false;
        this.errmsg = null;
    }

    ionViewWillEnter() {
        // bij elke keer openen pagina
        this.ajax.get('logout')
            .then((data: any) => {
                console.log('user logged out.');
            });
        this.global.isLoggedIn = false;
        this.errmsg = null;
    }

    ionViewDidEnter() {
        setTimeout(() => {
            if (this.inpCompany) {
                if (this.inpUsr) {
                    this.inpPwdFld.setFocus();
                } else {
                    this.inpUsrFld.setFocus();
                }
            } else {
                this.inpCmpFld.setFocus();
            }
        }, 200);
    }

    delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    pwdBlur() {
        setTimeout(() => {
            if (this.inpUsr.length>20) this.login();
            if (this.inpPwd.length>20) this.login();
        }, 200);
    }

    async login() {
        this.wait = true;
        console.log('Login');
        this.showpwd = false;
        this.inpCompany = this.inpCompany.trim().toLowerCase();
        console.log(this.inpCompany, this.inpUsr);
        localStorage.setItem('autoLogin', (this.autoLogin) ? '1' : '0');

        this.global.session = '';

        if (this.inpCompany === 'dev') {
            this.global.baseurl = 'http://localhost/dev/';
        }

        if (this.inpUsr.length>20 && !this.inpPwd) {
            this.inpPwd = this.inpUsr;
            this.inpUsr = '';
        }

        await this.delay(500);

        this.ajax.get('login', {
            compname: this.inpCompany.toLowerCase(),
            username: this.inpUsr,
            password: this.inpPwd,
            pcnr: this.global.uuid,
            devID: this.global.devID,
            autoLogin: this.autoLogin,
        }).then(async (data: any) => {
            console.log('recvd data: ', data);
            if (data.login) {
                console.log('login succesfull');
                await this.processLoginData(data);
                this.router.navigateByUrl(this.global.startPage);
                this.wait = false;
            } else {
                console.log('login failure');
                this.errmsg = data.msg;
                this.wait = false;
            }
        }, error => {
            console.log('Communicatie error: ', error);
            this.errmsg = 'Error contacting server. Check your connection.';
            this.wait = false;
        });
    }

    async processLoginData(data) {
        this.global.isLoggedIn = true;
        this.global.compname = data.dbname;
        this.inpUsr = (data.session) ? data.sessionusr : this.inpUsr;
        this.global.username = this.inpUsr;
        this.global.password = (data.session) ? '' : this.inpPwd;
        this.global.usrvalue = data.usrvalue;
        this.global.usrlevel = Number(data.usrlvl);
        this.global.session = data.session;
        this.global.baseurl = 'https://cloud.lisaas.com/' + this.global.compname + '/';

        if (this.inpCompany === 'dev') {
            this.global.baseurl = 'http://localhost/dev/';
        }

        if (this.inpPwd.length>20) {
            this.inpPwd = '';
            this.inpUsr = '';
        } else {
            // iOS autofill save password functionality removed
            console.log('Login successful for user:', this.inpUsr);
        }
        this.global.latestVersion = data.version;
        this.global.apkurl = data.apk;
        this.errmsg = null;
        localStorage.setItem('company', this.global.compname);
        localStorage.setItem('user', this.inpUsr);
        this.global.var = data.var;
        if ("app-orders-afgesloten-niveau" in this.global.var) {
            this.global.var["app-orders-afgesloten-niveau"] = Number(this.global.var["app-orders-afgesloten-niveau"]);
        } else {
            this.global.var["app-orders-afgesloten-niveau"] = -1;
        }
        if ("app-orders-actueel-niveau" in this.global.var) {
            this.global.var["app-orders-actueel-niveau"] = Number(this.global.var["app-orders-actueel-niveau"]);
        } else {
            this.global.var["app-orders-actueel-niveau"] = -1;
        }
        // console.log('variables set:', data.var);
        this.global.modules = data.modules;

        const afboekV2 = localStorage.getItem('afboekV2');
        this.global.optAfbV2 = (this.global.getvar('app-afboek-uitslag', '0')==='1');

        const inclBTW = localStorage.getItem('inclBTW');
        this.global.optInclBtw = (inclBTW === '1');

        const start = localStorage.getItem('start');
        if (start) {
            this.global.startPage = start;
        }
        if ("app-startpage" in this.global.var && typeof this.global.var["app-startpage"] === 'string' && this.global.var["app-startpage"] !== '0') {
            this.global.startPage = this.global.var["app-startpage"];
        }
        console.log('startPage=', this.global.startPage);

        this.app.appPages.find(item => item.url === '/home').hide = (this.global.optAfbV2 || this.global.getvar('app-show-artinfo', '1') === '0');
        this.app.appPages.find(item => item.url === '/afboeking').hide = (this.global.optAfbV2 || this.global.getvar('app-show-afboeking', '1') === '0');
        this.app.appPages.find(item => item.url === '/afboeking2').hide = !this.global.optAfbV2;
        this.app.appPages.find(item => item.url === '/overboeking').hide = (this.global.getvar('app-voorraad-p2p', '0') === '0');
        this.app.appPages.find(item => item.url === '/map').hide = (this.global.getvar('app-voorraad-object', '0') === '0');
        this.app.appPages.find(item => item.url === '/bedrijven').hide = (this.global.getvar('app-voorraad-lisapp', '1') === '0' || this.global.getvar('app-show-bedrijven', '1') === '0');
        this.app.appPages.find(item => item.url === '/object').hide = (this.global.getvar('app-voorraad-object', '0') === '0');
        this.app.appPages.find(item => item.url === '/orders').hide = false;
        this.app.appPages.find(item => item.url === '/uren').hide = (this.global.getvar('app-voorraad-lisapp', '1') === '0');

        this.app.appPages.find(item => item.url === '/voorraadmutatie').hide = ((this.global.compname !== 'im'));

        for (let url in data.i18n.menu) {
            this.app.appPages.find(item => item.url === '/' + url).title = data.i18n.menu[url];
        }

        if (this.app.appPages.find(item => item.url === this.global.startPage).hide) {
            // startpage is hidden, zoek een andere
            for (let item of this.app.appPages) {
                if (!item.hide) {
                    this.global.startPage = item.url;
                    break;
                }
            }
        }
    }

    async doScan() {
        if (!await this.global.startCamera()) {
            return;
        }
        this.scanCamera = true;
        const myDlg = await this.modalController.create({
            component: ScanCameraPage,
        });
        myDlg.onDidDismiss()
        .then((dataPar: OverlayEventDetail) => {
            this.scanCamera = false;
            if (dataPar.data.code) {
                this.inpPwd = dataPar.data.code;
                this.pwdBlur();
            }
        });
        return await myDlg.present();
    }

}
